module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-chevron-216891f1122bfbabff7421604a333664.svg";